import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import RouterComponent from "./components/common/RouterComponent";
import { SidebarProvider } from "./context/SidebarContext";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ToastManager from "./components/common/ToastManager";

const LoadingComponent = () => (
  <div className="loading-state">
    <div className="spinner">Loading...</div>
  </div>
);

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<LoadingComponent />} persistor={persistor}>
        <SidebarProvider>
          <div className="app">
            <RouterComponent />
          </div>
          <ToastManager />
        </SidebarProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;